import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

import s from './SMTPInfo.css';
import SMTPManagement from '../../../components/siteadmin/SMTPManagement/SMTPManagement';

function SMTPInfo() {
  const [currentPage, setCurrentPage] = useState(1);

  const setStateVariable = (variables) => {
    if (variables.currentPage !== undefined) {
      setCurrentPage(variables.currentPage);
    }
  };

  return (
    <SMTPManagement
      setStateVariable={setStateVariable}
      currentPage={currentPage}
    />
  );
}

SMTPInfo.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getAllSmtpData: PropTypes.array,
  }),
};

SMTPInfo.defaultProps = {
  data: {
    loading: true,
  },
};

export default withStyles(s)(SMTPInfo);